// extracted by mini-css-extract-plugin
export default {"Column":"kgsRjTO2Bu","Card":"VcvBJGhDg0","Description":"LEJRpIWFMP"};